import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { userAPI } from '../lib/api';
import { isNativeApp } from '../lib/platform';
import { adsAllowedOn, getAdSenseConfig, loadAdSense } from '../lib/adsense';

// Loads the AdSense script (Auto ads) on website content pages once the admin has switched ads on.
export function AdSenseManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (isNativeApp() || !adsAllowedOn(pathname)) return;
    let alive = true;
    getAdSenseConfig(userAPI.getAdsConfig).then((cfg) => {
      if (alive && cfg.enabled) loadAdSense(cfg.client_id);
    });
    return () => { alive = false; };
  }, [pathname]);
  return null;
}

// A responsive AdSense ad unit (website only, only when the admin entered a banner ad unit ID).
export function GoogleAdBanner({ className = '' }) {
  const [cfg, setCfg] = useState(null);
  const pushed = useRef(false);
  const { pathname } = useLocation();
  const native = isNativeApp();

  useEffect(() => {
    if (native) return undefined;
    let alive = true;
    getAdSenseConfig(userAPI.getAdsConfig).then((c) => { if (alive) setCfg(c); });
    return () => { alive = false; };
  }, [native]);

  const show = !native && cfg?.enabled && cfg?.banner_slot_id && adsAllowedOn(pathname);

  useEffect(() => {
    if (!show || pushed.current) return;
    if (loadAdSense(cfg.client_id)) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch (e) {
        /* ad blockers etc. */
      }
    }
  }, [show, cfg]);

  if (!show) return null;
  return (
    <div className={`w-full overflow-hidden ${className}`} data-testid="google-ad-banner">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={cfg.client_id}
        data-ad-slot={cfg.banner_slot_id}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
